import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';



const ProfileFeedback = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);
    const [feedback, setFeedback] = useState(null);

useEffect(() => {

        if(!localStorage.getItem('@roampays-user')){
            navigate("/login")
          }
      
     }, []);

    const saveFeedback = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(null);

       
        if (!feedback ) {
            setErrorResponse("Enter feedback ");
            setIsBtn(false)
        } else {

           
            await axios.post(process.env.REACT_APP_API_URL + "/save-feedback", {
                feedback: feedback,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {


                        setErrorResponse("Your feedback has been sent. ");
                        setFeedback("");
                       // navigate("/profile");



                    } else {

                        setErrorResponse(response?.data?.message);

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };

    
    const backToProfile = async (e) => {
        navigate("/profile")
    };

    return (

        <>
   <div className="title-box">

<div className="flex-equal justify-content-start " >
    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToProfile} >

        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
        </svg>
        <label >Back</label>

    </button>

</div>
<h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Feedback</h3>
<div className="flex-equal justify-content-end" ></div>

</div>



<div className="box" >

                <div className="form-content" >

                {errorResponse &&
                <div className="fs-14  color-white" role="alert">
                    {errorResponse}
                </div>
            }
                  <div className="input-container" >
                  <label >Feedback</label>

                        <textarea rows="4" className="color-light fs-14" id="feedback"
                            name="feedback" 
                            onChange={(e) => setFeedback(e.target.value)}
                            >
                            {feedback}
                            </textarea>
                            
                     


                    </div>
                 
                </div>


                </div>
                <div className="form-action">

<div className="action-bar ">

    <div className="button-box">

        <button className="btn btn-secondary" type="button" onClick={backToProfile}>Cancel</button>
        <button className="btn btn-primary" onClick={saveFeedback} disabled={isBtn}>
            {isBtn ? <Loading size={'20px'} /> : 'Save'}</button>

    </div>
</div>

</div>






        </>


    );
};

export default ProfileFeedback;